import { useState } from 'react';
import { ApiError, api } from '../api.js';
import { payInvoice } from '../payments.js';
import { useApp } from '../store.js';

const dateRu = (iso: string) => new Date(iso).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });

/** «+1 билет в день» за Stars: действующие слоты со сроком и покупка/продление. */
export function SlotOffer() {
  const token = useApp((s) => s.token);
  const me = useApp((s) => s.me);
  const open = useApp((s) => s.slotOfferOpen);
  const setOpen = (v: boolean) => useApp.setState({ slotOfferOpen: v });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  if (!me) return null;
  const { slots } = me.tickets;
  if (!slots.starsEnabled && slots.active === 0) return null;
  const full = slots.active >= slots.max;

  const buy = async () => {
    if (!token || busy) return;
    setBusy(true);
    setMsg(null);
    try {
      const { link } = await api.ticketSlotInvoice(token);
      if (!(await payInvoice(link))) return;
      // Слот выдаётся по уведомлению Telegram — ждём его немного
      for (let i = 0; i < 10; i++) {
        const t = await api.tickets(token);
        if (t.slots.expiresAt.join() !== slots.expiresAt.join()) {
          const cur = useApp.getState().me;
          if (cur) useApp.setState({ me: { ...cur, tickets: t } });
          setMsg('Готово! Билетов в день стало больше');
          return;
        }
        await new Promise((r) => setTimeout(r, 1000));
      }
      setMsg('Оплата прошла, билет появится через минуту');
    } catch (err) {
      setMsg(
        err instanceof ApiError && err.message === 'stars_disabled'
          ? 'Оплата звёздами пока недоступна'
          : 'Не получилось',
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" className="chip chip--small" onClick={() => setOpen(true)}>
        {slots.active > 0 ? `⭐ +${slots.active}/день` : '⭐ +1/день'}
      </button>
      {open && (
        <div className="overlay" role="dialog" aria-label="Больше билетов">
          <div className="ticket-modal__icon" aria-hidden="true">
            🎟⭐
          </div>
          <p>+1 бесплатный билет каждый день</p>
          <p className="overlay__hint">
            На {slots.days} дней · {slots.priceStars} ⭐ · можно до +{slots.max} (до{' '}
            {me.tickets.freeMax - slots.active + slots.max} билетов в день)
          </p>
          {slots.expiresAt.map((e, i) => (
            <p key={e} className="overlay__hint">
              Слот {i + 1}: до {dateRu(e)}
            </p>
          ))}
          {slots.starsEnabled && (
            <button type="button" className="play play--small" disabled={busy} onClick={() => void buy()}>
              {busy
                ? '…'
                : full
                  ? `Продлить на ${slots.days} дней — ${slots.priceStars} ⭐`
                  : `Купить за ${slots.priceStars} ⭐`}
            </button>
          )}
          {msg && <p className="overlay__hint">{msg}</p>}
          <p className="overlay__hint">Сила удара и сейва не меняется — только больше турниров</p>
          <button type="button" className="link" onClick={() => setOpen(false)}>
            Закрыть
          </button>
        </div>
      )}
    </>
  );
}
